<template>
  <div class="Dialogs">
    <div class="main">
      <div class="right" v-if="val == 2">
        <div class="right_div" v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智能报账</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox">
                  <p>ESCloud 智能报账包括商旅和费控一体化管理、企业支出一体化管理、业务收入一体化管理。</p>
                  <p>智能报账可支撑全员应用，全程可以伴随影像系统实现无纸化高效办公；电子发票服务实现对进项电子发票自动化验真与查重，并实现零人工成本发票自动核验。</p>
                </div>
                <img class="imgeec1-3" src="../assets/images/portfolio/dialog/esc/智能报账1.png" alt="" />
              </div>
            </div>
            <div class="two">
              <h5 class="padHeight lyd-title-colo1">商旅与费控一体化管理：</h5>
              <img class="imgeec1-4 margin0auto padHeight_imgmian2" src="@/assets/images/portfolio/dialog/esc/智能报账2.png"
                alt="" />
              <br>
              <img class="imgeec1-4 margin0auto padHeight_imgmian2" src="@/assets/images/portfolio/dialog/esc/智能报账3.png"
                alt="" />
              <h5 class="padHeight">对公业务的企业支出一体化管理：</h5>
              <div class="padHeight">
                <div class="padHeight-item">
                  <div>
                    <ul>
                      <li>与供应链、项目管理、人力管理、资产管理等一体化的企业支出管理，杜绝人为错误发生。</li>
                      <li>每笔采购应付业务的可分析，可追溯。</li>
                      <li>进行采购应付和付款业务的核销处理，并为后续的财务分析提供更细颗粒度的数据支持。</li>
                      <li>资产一体化管理。</li>
                    </ul>
                  </div>
                  <img src="@/assets/images/portfolio/dialog/esc/智能报账4.png" alt="">
                </div>
              </div>

              <h5 class="padHeight">业务收入一体化管理：</h5>
              <div class="padHeight">
                <div class="padHeight-item conts-alinetimecenter">
                  <div>
                    <p>ESCloud业务收入一体化管理包括销售业财即销售管理系统与应收收入确认的一体化管理以及收款认领管理。</p>
                    <p>
                      通过合同、客户相关业务处理，实现应收款项核销、自动进行往来对账、结算管理、提供应收款项回款分析、账龄分析、周转分析、往来对账等功能，并能根据不同设置提供债权、催款提示等。
                    </p>
                  </div>
                  <img src="@/assets/images/portfolio/dialog/esc/智能报账5.png" alt="">
                </div>
              </div>
              <div class="padHeight">
                <div class="padHeight-item conts-alinetimecenter">
                  <div class="width80">
                    <p>
                      通过收款认领平台，基于银行下载流转/手工导入流水，人工/系统自动确认收款流水生成收款单据，收款单审核通过自动结算入账处理。实现收款单、电子回单、凭证三单匹配。
                    </p>
                  </div>
                  <img src="@/assets/images/portfolio/dialog/esc/智能报账6.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">发票管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <p>EECloud发票管理与智能报账、影像系统、税务管理一体化应用，实现进项发票的归集、自动查验、自动查重、解析、存管、报销入账等全流程过程管理。</p>
                <img class='imgeec1-2' src="@/assets/images/portfolio/dialog/eec/发票管理1.png" alt="" />
              </div>
              <div class="cont mt3">
                <p>产品支持发票夹采集发票功能，票小记发票夹提供APP和微信小程序两种使用途径，支持拍照采集、上传图片、扫描二维码、微信卡包引入、文件导入、手工采集等6种方式采集发票信息。
                </p>
                <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/eec/发票管理2.png" alt="" />
              </div>
              <div class="cont mt3">
                <p>且支持对增值税发票进行查验，票据自动转存影像文件，用于报销审核及电子档案存储。对已采集的发票可进行转让，适用于多种业务报账场景。</p>
                <img class='imgeec1-3' src="@/assets/images/portfolio/dialog/esc/发票管理3.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">电子影像与档案管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox">
                  <p>影像管理是通过发票、纸质单据等扫描以及OCR识别，实现业务系统运营集中化、纸质单据影像化、业务流程处理便捷化。包括影像采集、影像处理、影像展现、影像存储等部分。</p>
                  <p>
                    建立企业级影像管理平台，将合同、对账单、发票等扫描管理，通过发票号、合同号、对账单号等任何信息都可以查询到相关的档案，实现将整个业务链产生的所有档案全部进行显示调阅，实现业务可追溯，提升企业运营效率。
                  </p>
                </div>
                <img class="imgeec1-1" src="../assets/images/portfolio/dialog/esc/发票管理1.png" alt="" />
              </div>
              <div class="cont mt3">
                <div class="contentBox">
                  <p>通过构建电子档案统一管理体系，实现文件资料的分类、归档、上传、下载、检索、管理等全业务电子化、自动化归档以及可靠的安全性，对所有的电子档案资料进行生命周期管理。</p>
                  <p>通过会计档案的无纸化管理，减少企业打印成本、IT耗材、存管人力和空间成本等，节能减排，绿色环保，减少生产办公成本。</p>
                </div>
                <img class="imgeec1-1" src="@/assets/images/portfolio/dialog/esc/电子影像1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '3'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">一键报税</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>增值税管理通过发票夹多种采集方式进行发票采集，与报账系统关联引用发票信息便捷填单，按照税法要求自动进行价税分离，满足增值税核算要求。</p>
                  <p>与核算系统对接，实时传递发票对应账务信息，且与税局对接，实现一键认证。</p>
                  <p>出具进项发票台账、抵扣统计表以及其他扣税明细表等统计报表且关联单据以及财务入账凭证，便于税务人员进行查询统计。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/一键报税.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '4'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">资金结算</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    实现资金业务处理信息化、自动化、不落地处理，提升结算效率，加速资金流转，提升整体效益，通过加强内部资金统一调配，加速内部资金周转，降低资金沉淀量，提高整体资金使用效益。
                  </p>
                  <p>通过银企直联、RPA网银机器人完成资金的统一支付，并通过头寸管理结合资金计划严控资金头寸，保障资金安全。</p>
                  <p>实现资金的逆向流程线上管理，实现对于错付退回、银行账户有误逆向流程的线上审批，避免出现重付、多付、账务核算错误、账户错误无人监控的情况。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/资金结算.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '5'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">移动应用</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <!-- <h5 class="padHeight">（1）移动报销：将费用报销与费用申请、事务申请、金额管控、发票管控等集成，并结合与预算管控、成本中心管控要求，实现费用归集，并通过报表展示费用的发生情况。</h5>
                  <h5 class="padHeight">（2）移动审批，用户随时随地通过APP、钉钉、企业微信、飞书、企业OA等种社交软件使用审批功能，对要素事项进行提醒，感受审批便捷；</h5> -->
                  <p>移动报销：将费用报销与费用申请、事务申请、金额管控、发票管控等集成，并结合与预算管控、成本中心管控要求，实现费用归集，并通过报表展示费用的发生情况。</p>
                  <p>移动审批：用户随时随地通过APP、钉钉、企业微信、飞书、企业OA等种社交软件使用审批功能，对要素事项进行提醒，感受审批便捷。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/移动应用.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '6'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">连接器</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>ESCloud的Business Connector（连接器模块），可将其他业务系统等无缝与ESCloud整合。通过统一数据连接器充分结合，让连接+报账实现业财的全面融合。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="@/assets/images/portfolio/dialog/esc/连接器.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '7'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">会计引擎</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox">
                  <p>当企业已经应用了核算系统基础上，可通过ESCloud会计引擎，智能化、自动化生成财务核算系统凭证，实现智能记账。</p>
                </div>
                <img class="imgeec1-1" src="@/assets/images/portfolio/dialog/esc/会计引擎1.png" alt="" />
              </div>
              <div class="cont mt3">
                <div class="contentBox">
                  <p>会计引擎可定义、可配置不同行业和企业性质的凭证生成模板，只需基础会计知识即可。</p>
                </div>
                <img class="imgeec1-1" src="@/assets/images/portfolio/dialog/esc/会计引擎2.png" alt="" />
              </div>
              <div class="cont mt3">
                <div class="contentBox">
                  <p>可与主流ERP、财务等不同的异构系统集成，ESCloud通过会计引擎都能迅速地、自动化生成会计凭证。</p>
                </div>
                <img class="imgeec1-1" src="@/assets/images/portfolio/dialog/esc/会计引擎3.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '8'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">项目管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>包括项目立项、项目进度、合同管理、项目预算管理，从投标、中标、合同签订、合同履行到项目验收结算的项目全过程管理；加强公司对项目全过程管控能力，降低项目风险。</p>
                  <ul class="padHeight">
                    <li>投标、合同签订、采购及使用、项目过程等全业务协同。</li>
                    <li>建立计划管理体系，强化计划管理，加强过程成本控制。</li>
                    <li>以项目进度管理、成本管理为核心，构建全过程项目管理平台。</li>
                    <li>支持集团型管控，大到集团、小到分公司、项目部都可用。</li>
                    <li>核算、决算闭环并实现人工、材料、机械、其他费用等全成本管理。</li>
                    <li>实现业务流、资金流、信息流三流合一，并与财务系统无缝对接。</li>
                  </ul>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="../assets/images/portfolio/dialog/esc/项目管理.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" v-if="val == 3">
        <div class="right_div" v-if="leftInd == '0'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">预算管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>
                    ESCloud预算管理一站式覆盖预测、经营计划、执行管控、滚动预算、分析考核各个环节，实现全面预算闭环管理，助力企业精细化运营。包括预算体系创建、预算编制、预算控制、预算执行与分析。数据赋能业务，伴随企业成长。
                  </p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="../assets/images/portfolio/dialog/esc/budgetImg@4x.png"
                  alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '1'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智能报表</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>ESCloud智能报表支持在多会计准则、多币种、法定及管理多组织架构等各种复杂环境下，准确、自动生成报表。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="../assets/images/portfolio/dialog/esc/reportForm.jpeg"
                  alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="right_div" v-if="leftInd == '2'">
          <div class="right-top" data-aos="fade-up">
            <div class="one">
              <div class="fs-2 w-700 lyd-title-colo1">智能分析管理</div>
              <div class="bar"></div>
              <div class="cont mt3">
                <div class="contentBox width100">
                  <p>ESCloud智能分析通过业财数据中台，对回顾企业过去、评价企业现状、预测企业未来做出正确决策提供准确的信息和依据。</p>
                  <p>ESCloud智能分析包括盈利能力分析、偿债能力分析、资产运营能力分析、发展能力分析等。</p>
                </div>
                <img class="imgmian2 mrgintop0 mt3" src="../assets/images/portfolio/dialog/esc/management.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="closes" @click="close">
        <div class="clo-btn">返回<i class="bi bi-chevron-right"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderShow from '@/components/common/dialog/orderShow.vue'
export default {
  name: 'moveEsc',
  components: { OrderShow, },
  props: {
    leftInd: '',
    val: '',
  },
  // data() {
  //   return {
  //     leftInd: 0,
  //     val: 2,
  //   }
  // },
  mounted() {
    console.log(123123123);
  },
  watch: {
    $route: {
      handler: function (to, from) {
        console.log(to.params);
        this.leftInd = to.params.type
        this.val = to.params.val
      }
    },
  },
  methods: {
    close() {
      this.$emit('toclose', '')
      // this.$router.go(-1)
    },
  }
}
</script>

<style lang="scss">
.Dialogs {
  h5 {
    font-size: 13px !important;
  }

  li {
    font-size: 12px !important;
  }

  img {
    text-align: center;
    height: auto;
    width: 100%;
  }

  .padHeight {
    margin: 3rem 0;
  }

  .right-top {
    .one {
      .cont {
        margin: 3rem 0;
        display: block !important;
      }
    }
  }

  .padHeight {
    margin: 3rem 0;

    .padHeight-item {
      margin-top: 3rem;
    }
  }

  .bar {
    height: 3px;
    width: 25px;
    background: #005bab;
  }

  .margin0auto {
    margin: 0 auto;
    display: block;
  }

  .imgeec1-1 {
    width: 50rem !important;
  }

  .imgeec1-2 {
    height: 18.5rem !important;
  }

  .imgeec1-3 {
    width: 500px
  }

  .imgeec1-4 {
    width: 800px
  }

  .imgeec1-100 {
    width: 100%
  }

  .conts-alinetimecenter {
    align-items: center;
  }

  .width100 {
    width: 100% !important
  }
}
</style>
<style lang="scss">
.Dialogs {
  display: block;

  .main {
    position: fixed;
    top: 80px;
    display: flex;
    justify-content: center;
    width: 100vw;
    max-width: 1920px;

    .right {
      flex: 1;
      height: 100%;
      background: #fff;
      padding: 2rem;
      overflow: auto;
      height: calc(100vh - 80px);
      .right_div{
        margin-bottom: 80px;
      }
      .right-top {
        .one {
          .cont {
            margin: 3rem 0;
          }

          .contentBox {
            flex: 1;
            margin-right: 5rem;
          }
        }
      }
    }
  }

  .closes {
    position: absolute;
    top: 2rem;
    right: 2rem;
    cursor: pointer;

    .clo-btn {
      font-size: 10px;
      width: 60px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #676767;
      border-radius: 5px;
      background: #f9f9f9;
    }
  }
}

.padHeight {
  margin: 3rem 0;
}
</style>